module.exports = __webpack_public_path__ + "img/12-Glass-filled-with-Tomato-Juice-(1)-min.d14b4a14.png";